'use client';

import { Slider as SliderPrimitive } from 'radix-ui';

import { cn } from '@/lib/utils';

/**
 * Minimal zinc slider on the Radix primitive: 2px track, square thumb —
 * echoing the hand-rolled range input in narration-player.tsx. Radix scopes
 * touch-action to the thumb, so page scroll survives on mobile.
 */
function Slider({
  className,
  'aria-label': ariaLabel,
  ...props
}: React.ComponentProps<typeof SliderPrimitive.Root>) {
  return (
    <SliderPrimitive.Root
      data-slot="slider"
      className={cn(
        'relative flex w-full touch-none items-center select-none',
        'data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
        className
      )}
      {...props}
    >
      <SliderPrimitive.Track className="relative h-0.5 w-full grow bg-muted">
        <SliderPrimitive.Range className="absolute h-full bg-foreground" />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        // The thumb is the focusable role="slider" element, so the accessible
        // name must live here, not on the root.
        aria-label={ariaLabel}
        className={cn(
          'block size-3 shrink-0 border border-foreground bg-background',
          'transition-[scale] hover:scale-110 active:scale-125',
          'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background focus-visible:outline-none'
        )}
      />
    </SliderPrimitive.Root>
  );
}

export { Slider };
